import AppLayout from "@/layouts/app/AppLayout";

import dashboard from "./dashboard"

export default [
  

  {
    path: "/speaker",
    component: AppLayout,
    meta: {
      middleware: ["auth"],
      roles: ["speaker"],
    },
    children: [
        ...dashboard,
    ],
  },
];
